import React from 'react'
import Link from 'next/link'

import LcIcon, { LcIconName } from '@/components/livecontact/icons'

type Props = {
  title: string
  description?: React.ReactNode
  icon?: LcIconName
  backHref?: string
  backLabel?: string
}

/**
 * Shared heading for the guest-auth cards. The wordmark lives in the layout now, so this
 * starts at the optional back link and centres everything below it to match the column.
 */
const AuthHeading = ({
  title,
  description,
  icon,
  backHref,
  backLabel = 'Back to sign in',
}: Props) => (
  <div className="mb-6 flex flex-col items-center gap-4 text-center">
    {backHref && (
      <Link
        href={backHref}
        className="group inline-flex w-fit items-center gap-1 rounded-[8px] px-1 text-[13px] font-medium tracking-[-0.2px] text-ink-3 outline-none transition-colors duration-[140ms] hover:text-ink focus-visible:ring-2 focus-visible:ring-brand/40"
      >
        <LcIcon
          name="chevron-left"
          className="transition-transform duration-[160ms] ease-out-strong group-hover:-translate-x-0.5"
        />
        {backLabel}
      </Link>
    )}
    {icon && (
      <span className="inline-flex size-[42px] items-center justify-center rounded-[12px] bg-surface text-brand shadow-[0_0_0_1.25px_rgb(var(--lc-line))] animate-lc-pop">
        <LcIcon name={icon} size={22} />
      </span>
    )}
    <div className="flex flex-col gap-1">
      <h1 className="text-[22px] font-medium leading-[1.3] tracking-[-0.3px] text-ink">{title}</h1>
      {description && (
        <p className="text-[14px] leading-[1.4] tracking-[-0.2px] text-ink-3">{description}</p>
      )}
    </div>
  </div>
)

export default AuthHeading
